import {
  IBundleProductCharacteristic,
  IProductSpecificationItemCharacteristic
} from "./types";

export default class BundleProductCharacteristic implements IBundleProductCharacteristic {

  id: number;
  specificationItemCharacteristic: IProductSpecificationItemCharacteristic;
  value: string;
  valueEn: string;
  characteristicIdentifier: string;
  specificationIdentifier: string;
  specificationItemCharacteristicId: number;

  constructor(
    id: number,
    specificationItemCharacteristic: IProductSpecificationItemCharacteristic,
    value: string,
    valueEn: string,
    characteristicIdentifier: string,
    specificationIdentifier: string,
    specificationItemCharacteristicId: number
  ) {
    this.id = id;
    this.specificationItemCharacteristic = specificationItemCharacteristic;
    this.value = value;
    this.valueEn = valueEn;
    this.characteristicIdentifier = characteristicIdentifier;
    this.specificationIdentifier = specificationIdentifier;
    this.specificationItemCharacteristicId = specificationItemCharacteristicId;
  }

}
